import { useHistory } from 'react-router-dom';
import * as AlertDialog from '@givebutter/primitives/alert-dialog';

const MINIMUM_WINDOW_SIZE = 800;
const SmallBrowserAlertDialog = () => {
    const history = useHistory();

    return (
        <AlertDialog.Root type="warning" open={window.innerWidth < MINIMUM_WINDOW_SIZE}>
            <AlertDialog.Portal>
                <AlertDialog.Overlay />
                <AlertDialog.Content>
                    <AlertDialog.Header>
                        <AlertDialog.Icon />
                    </AlertDialog.Header>
                    <AlertDialog.Body>
                        <AlertDialog.Title>Your browser is too small.</AlertDialog.Title>
                        <AlertDialog.Description>
                            Increase the size of your browser to a minimum of {MINIMUM_WINDOW_SIZE}
                            px or use a laptop or desktop computer to continue using workflows.
                        </AlertDialog.Description>
                    </AlertDialog.Body>
                    <AlertDialog.Footer>
                        <AlertDialog.Action
                            onClick={() => {
                                if (history.length > 2) {
                                    history.goBack();
                                } else {
                                    history.push('./');
                                }
                            }}
                        >
                            Go back
                        </AlertDialog.Action>
                    </AlertDialog.Footer>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
};

export { SmallBrowserAlertDialog };
